import React from "react";
import { useLocation } from "react-router-dom";
import "../Invitation/styles.css";
export default function InviteSuccess() {
  const location = useLocation();
  const { status } = location.state || {};
  const getFailText = () => {
    switch (status) {
      case 1:
        return "该邀请链接已使用";
      case 1:
        return "该邀请链接已过期";
      default:
        return "请求失败";
    }
  };
  return (
    <div style={{ textAlign: "center", marginTop: "100px" }}>
      <h1>邀请失败</h1>
      <p>{getFailText()}</p>
      <button className="submit-btn">下载“伴知宠”</button>
    </div>
  );
}
